import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils.js';
const buttonVariants = cva('inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-[color,background-color,border-color,box-shadow,transform] duration-150 outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 active:translate-y-px [&_svg]:size-4 [&_svg]:shrink-0', {
    variants: {
        variant: {
            default: 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 hover:shadow-md',
            secondary: 'bg-muted text-foreground shadow-xs hover:bg-muted/70 hover:shadow-sm',
            outline: 'border border-border bg-card text-foreground shadow-xs hover:bg-muted hover:shadow-sm',
            ghost: 'hover:bg-muted text-foreground',
            destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 hover:shadow-md',
            link: 'text-primary underline-offset-4 hover:underline',
        },
        size: {
            default: 'h-9 px-4 py-2',
            sm: 'h-8 rounded-md px-3 text-xs',
            lg: 'h-10 rounded-md px-6',
            icon: 'h-9 w-9',
        },
    },
    defaultVariants: { variant: 'default', size: 'default' },
});
export const Button = React.forwardRef(({ className, variant, size, ...props }, ref) => (_jsx("button", { ref: ref, className: cn(buttonVariants({ variant, size }), className), ...props })));
Button.displayName = 'Button';
export { buttonVariants };
